import { uploadCompaniesToProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useLoadCompaniesToProject = (projectId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      projectId,
      file,
    }: {
      projectId: string;
      file: globalThis.File;
    }) => await uploadCompaniesToProject(projectId, file),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectCompanies, projectId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.ProjectListings, projectId],
        }),
      ]);
    },
  });
};
